<template>
  <div>
    <p v-if="! agreementFilesRows.length">No Agreements uploaded</p>
    <agreement-files-row
      v-for="agreementFilesRow in agreementFilesRows"
      :agreementFilesRow="agreementFilesRow"
      :key="agreementFilesRow.id"
      :rollOutId="rollOut.id"
      @rowDeleted="deleteRow"
    />
    <button class="btn btn-primary"
      @click="createRow"
      v-if="canCreateRow"
    >
      Upload another row
    </button>
  </div>
</template>

<script>
  export default {
    props: ['rollOut'],
    data() {
      return {
        agreementFilesRows: this.rollOut.agreement_files_rows,
      }
    },
    methods: {
      createRow () {
        window.axios.post(`/roll_outs/${this.rollOut.id}/agreement_files_rows`).then(({data}) => this.agreementFilesRows.push(data))
      },
      deleteRow (row) {
        const index = this.agreementFilesRows.findIndex(afr => afr.id === row.id)
        this.agreementFilesRows.splice(index, 1)
      },
    },
    computed: {
      canCreateRow () {
        const rows = this.agreementFilesRows.length
        return rows === 0 || (this.agreementFilesRows[rows - 1].bc_file || this.agreementFilesRows[rows - 1].ka_file || this.agreementFilesRows[rows - 1].d_file)
      },
    },
  }
</script>



// WEBPACK FOOTER //
// resources/js/components/roll_outs/AgreementFilesRows.vue